var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"app-page"},_vm.$listeners),[_c('div',{staticClass:"container"},[_vm._t("default")],2),_c('div',{staticClass:"footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }